import CrudRepository from './CrudRepository'
export default class WhoWeAreRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/about/type/0')
  }
}
